import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import style from "./FileTree.module.css";

@observer
class FileTree extends React.Component {
  getColorClassName(changeType) {
    if (changeType === `new`) {
      return style.added;
    }
    if (changeType === `updated`) {
      return style.updated;
    }
    if (changeType === `unchanged`) {
      return style.unchanged;
    }
    return null;
  }

  renderFileSvg() {
    return (
      <svg width="14px" height="18px" viewBox="0 0 70 90" version="1.1">
        <title>file</title>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="file" fill="#363D45">
            <path
              d="M70,20 L50,0 L0,0 L0,90 L70,90 L70,20 L70,20 Z M50,10.6 L59.4,20 L50,20 L50,10.6 L50,10.6 Z M62.5,82.5 L7.5,82.5 L7.5,7.5 L45,7.5 L45,25 L62.5,25 L62.5,82.5 L62.5,82.5 Z"
              id="Shape"
            />
            <rect id="Rectangle-path" x="15" y="35" width="40" height="5" />
            <rect id="Rectangle-path" x="15" y="45" width="40" height="5" />
            <rect id="Rectangle-path" x="15" y="55" width="40" height="5" />
            <rect id="Rectangle-path" x="15" y="65" width="40" height="5" />
          </g>
        </g>
      </svg>
    );
  }

  renderFolderSvg() {
    return (
      <svg width="18px" height="14px" viewBox="0 0 90 70" version="1.1">
        <title>folder</title>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <path
            d="M40,0 L0,0 L0,70 L90,70 L90,10 L50,10 L40,0 L40,0 Z M7.5,7.5 L36.9,7.5 L41.9,12.5 L7.5,12.5 L7.5,7.5 L7.5,7.5 Z M82.5,62.5 L7.5,62.5 L7.5,17.5 L82.5,17.5 L82.5,62.5 L82.5,62.5 Z"
            id="folder"
            fill="#363D45"
          />
        </g>
      </svg>
    );
  }

  renderFolder(folder) {
    const colorClassName = this.getColorClassName(folder.changeType);
    return (
      <div key={folder.path} className={style.folder}>
        <div
          style={{ paddingLeft: 10 * folder.depth }}
          className={colorClassName}
        >
          {this.renderFolderSvg()}
          <span>{folder.name}</span>
        </div>
      </div>
    );
  }

  renderFile(file) {
    const className =
      this.props.store.selectedFilePath === file.path
        ? style.selectedFile
        : style.file;
    const colorClassName = this.getColorClassName(file.changeType);
    return (
      <div
        key={file.path}
        className={className}
        onClick={event => {
          this.props.store.setSelectedFilePath(file.path);
          event.stopPropagation();
        }}
      >
        <div
          style={{ paddingLeft: 10 * file.depth }}
          className={colorClassName}
        >
          {this.renderFileSvg()}
          <span>{file.name}</span>
        </div>
      </div>
    );
  }

  renderTree(tree) {
    return tree.map(entity => {
      if (entity.type === `file`) {
        return this.renderFile(entity);
      }
      const result = [this.renderFolder(entity)];
      result.push(...this.renderTree(entity.children));
      return result;
    });
  }

  renderEmptyProject() {
    return (
      <div className={style.tree}>
        {this.renderFolder({
          path: `my-project`,
          name: `my-project`,
          depth: 0
        })}
      </div>
    );
  }

  render() {
    if (this.props.store.fileTree.length === 0) {
      return this.renderEmptyProject();
    }

    return (
      <div
        className={style.tree}
        onClick={() => {
          this.props.store.setSelectedFilePath(null);
        }}
      >
        {this.renderTree(this.props.store.fileTree)}
      </div>
    );
  }
}
FileTree.propTypes = {
  store: PropTypes.object.isRequired
};
export default FileTree;



// WEBPACK FOOTER //
// ./src/byos/component/FileTree.js